import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationComponent } from './notification/notification.component';
import { LiveMarketComponent } from './live-market/live-market.component';

@NgModule({
  declarations: [
    NotificationComponent,
    LiveMarketComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    NotificationComponent,
    LiveMarketComponent,
  ],
})
export class SharedModule {}
